//src/common/data/sensors.js

import { getUserData } from "../../../../../auth/views/login/auth.api.js";

const baseUrl = 'https://dashboard.pressuretrack.co.za/api';

const { token } = getUserData() || {};


//TO DO: Refactor and move to a more appropriate file, since it's not really about general sensor data. The same applies to updateTrailerName which is also not really about "sensors" per se.

// export async function updateTyreInfo(wheel) {
//   try {

//     const requestBody = {
//       externalTyreId: wheel.externalTyreId,
//       tyreTreadDepth: parseFloat(wheel.tyreTreadDepth),
//       flipRotation: !!wheel.flipRotation
//     };

//     const apiUrl = `${baseUrl}/sensor/${wheel.sensorId}/info`;

//     const response = await fetch(apiUrl, {
//       method: 'PUT',
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Accept': 'application/json',
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(requestBody)
//     });

//     const responseData = await response.json();

//     if (response.ok) {
//       console.log("Success:", responseData.message);
//     } else {
//       console.error("Error:", responseData);
//     }

//   } catch (e) {
//     console.error("Error updating tyre info:", e);
//   }
// }

export async function updateSensorFlipRotation(sensorId, flipRotation) {
  try {
    const { token } = getUserData() || {};

    const apiUrl = `${baseUrl}/sensor/${sensorId}/info`;

    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        flipRotation: !!flipRotation
      })
    });

    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        message: responseData?.message || 'Could not update temporary rotation fix.',
        data: responseData
      };
    }

    return {
      success: true,
      status: response.status,
      message: responseData?.message || 'Temporary rotation fix updated.',
      data: responseData
    };

  } catch (error) {
    console.error('Error updating temporary rotation fix:', error);

    return {
      success: false,
      status: null,
      message: 'A network error occurred while updating temporary rotation fix.',
      data: null
    };
  }
}

export async function updateSensorTyreInfo(sensorId, payload) {
  try {
    const { token } = getUserData() || {};

    const apiUrl = `${baseUrl}/sensor/${sensorId}/info`;

    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(payload)
    });

    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        message: responseData?.message || 'Could not update sensor tyre information.',
        data: responseData
      };
    }

    return {
      success: true,
      status: response.status,
      message: responseData?.message || 'Sensor tyre information updated.',
      data: responseData
    };

  } catch (error) {
    console.error('Error updating sensor tyre information:', error);

    return {
      success: false,
      status: null,
      message: 'A network error occurred while updating sensor tyre information.',
      data: null
    };
  }
}

export async function updateTrailerName(sensor, trailerName) {

  const repeaterId = sensor.repeater.repeaterId;
  const apiUrl = `${baseUrl}/repeater/${repeaterId}/info`;

  const requestBody = {
    trailerName: trailerName
  };

  try {
    const response = await fetch(apiUrl, {
      method: 'PUT', // Assuming it's a PUT request, change to POST if necessary
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    // Return true if the update was successful, else return false
    return response.ok;
  } catch (error) {
    console.error(`Error updating trailerName for repeaterId: ${repeaterId}`, error);
    return false; // Indicate that the update failed
  }
}

export async function getUnitSensorHistoryData(imei, date) {
  try {

    date = new Date(date);
    const timestamp = date.toISOString();

    const apiUrl = `${baseUrl}/unit/${imei}/sensor-historical?timestamp=${timestamp}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;

  } catch (e) {
    console.error('getsensordataJS: getUnitSensorHistory - ERROR ', e);
  }
}

export async function getStandAloneUnitSensorHistoryData(unitId, date) {
  try {

    date = new Date(date);
    const timestamp = date.toISOString();

    const apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/sensor-historical?timestamp=${timestamp}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;

  } catch (e) {
    console.error('getsensordataJS: getUnitSensorHistory - ERROR ', e);
  }
}


export async function getActionLogData(imei, wheelId) {
  try {
    const now = new Date();
    const sixMonthsAgo = new Date(now.setMonth(now.getMonth() - 6));
    const timestamp = sixMonthsAgo.toISOString();

    const apiUrl = `${baseUrl}/unit/${imei}/wheel/${wheelId}/action?startTimestamp=${timestamp}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      const rawErrorText = await response.text().catch(() => '');
      console.error('getActionLogData - HTTP error:', response.status, rawErrorText);

      // Try to parse JSON error body
      let backendMessage = '';
      try {
        const parsed = JSON.parse(rawErrorText);
        backendMessage = parsed?.message || rawErrorText;
      } catch {
        backendMessage = rawErrorText || '';
      }

      // Special-case: "End Date must be after Start Date"
      if (backendMessage.includes('End Date must be after Start Date')) {
        return {
          error: false,
          status: response.status,
          message: 'No actions have been logged for this wheel in the last 6 months.',
          actions: []
        };
      }

      // Generic error payload
      return {
        error: true,
        status: response.status,
        message: backendMessage || 'Unable to load the notification log.',
        actions: []
      };
    }

    const data = await response.json();

    return {
      error: false,
      status: response.status,
      message: null,
      ...data
    };

  } catch (e) {
    console.error('getsensordataJS: getActionLogData - ERROR ', e);

    return {
      error: true,
      status: null,
      message: 'A network error occurred while loading the notification log.',
      actions: []
    };
  }
}


export async function getStandAloneActionLogData(unitId, wheelId) {
  try {

    const now = new Date();
    const sixMonthsAgo = new Date(now.setMonth(now.getMonth() - 6));
    const timestamp = sixMonthsAgo.toISOString();

    const apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/wheel/${wheelId}/action?startTimestamp=${timestamp}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      const rawErrorText = await response.text().catch(() => '');
      console.error('getActionLogData - HTTP error:', response.status, rawErrorText);

      // Try to parse JSON error body
      let backendMessage = '';
      try {
        const parsed = JSON.parse(rawErrorText);
        backendMessage = parsed?.message || rawErrorText;
      } catch {
        backendMessage = rawErrorText || '';
      }

      // Special-case: "End Date must be after Start Date"
      if (backendMessage.includes('End Date must be after Start Date')) {
        return {
          error: false,
          status: response.status,
          message: 'No actions have been logged for this wheel in the last 6 months.',
          actions: []
        };
      }

      // Generic error payload
      return {
        error: true,
        status: response.status,
        message: backendMessage || 'Unable to load the notification log.',
        actions: []
      };
    }

    const data = await response.json();

    return {
      error: false,
      status: response.status,
      message: null,
      ...data
    };

  } catch (e) {
    console.error('getsensordataJS: getActionLogData - ERROR ', e);

    return {
      error: true,
      status: null,
      message: 'A network error occurred while loading the notification log.',
      actions: []
    };
  }
}

export async function updateActionLog(imei, wheelId, action) {
  try {

    const apiUrl = `${baseUrl}/unit/${imei}/wheel/${wheelId}/action`;
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ action: action })
    });

    const responseData = await response.json();

    if (response.ok) {
      console.log("Success:", responseData.message);
    } else {
      console.error("Error:", responseData);
    }

  } catch (e) {
    console.error("Error updating notification log:", e);
  }
}

export async function updateStandAloneActionLog(unitId, wheelId, action) {
  try {

    const apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/wheel/${wheelId}/action`;
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ action: action })
    });

    const responseData = await response.json();

    if (response.ok) {
      console.log("Success:", responseData.message);
    } else {
      console.error("Error:", responseData);
    }

  } catch (e) {
    console.error("Error updating notification log:", e);
  }
}

export async function fetchWheelSensorData(imei) {
  try {
    const apiUrl = `${baseUrl}/unit/${imei}/sensor`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;

  } catch (e) {
    console.error('getsensordataJS: fetchWheelSensorData - ERROR ', e);
  }
}

function buildQuery(params) {
  const qs = Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");
  return qs ? `?${qs}` : "";
}

export const fetchSensorHistoryData = async (imei, wheel, date, includeLocation = false) => {
  const params = {
    datapointInterval: 1,
    includeLocation
  };

  if (Array.isArray(date) && date.length === 2) {
    params.startTimestamp = date[0]; // will be encoded by buildQuery()
    params.endTimestamp = date[1];
  }

  const apiUrl = `${baseUrl}/unit/${imei}/wheel/${wheel}/history${buildQuery(params)}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json"
      },
      credentials: "include"
    });

    if (!response.ok) {
      const body = await response.text().catch(() => "");
      throw new Error(`History fetch failed (${response.status}) ${body}`);
    }

    return await response.json();
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};

export const fetchSensorHistoryDataStandAlone = async (unitId, wheel, date, includeLocation = false) => {
  const params = {
    datapointInterval: 1,
    includeLocation
  };

  if (Array.isArray(date) && date.length === 2) {
    params.startTimestamp = date[0];
    params.endTimestamp = date[1];
  }

  const apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/wheel/${wheel}/history${buildQuery(params)}`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json"
      },
      credentials: "include"
    });

    if (!response.ok) {
      const body = await response.text().catch(() => "");
      throw new Error(`Standalone history fetch failed (${response.status}) ${body}`);
    }

    return await response.json();
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    throw error;
  }
};


export const fetchSensorSummaryData = async (imei, date) => {

  let apiUrl = `${baseUrl}/unit/${imei}/sensor-summary`;

  // if (date) {
  //     apiUrl = `${baseUrl}/unit/${imei}/sensor-summary?startTimestamp=${date}}`;
  // } 

  // Check if 'date' is a single date object or an array with two date objects
  if (Array.isArray(date) && date.length === 2) {
    apiUrl = `${baseUrl}/unit/${imei}/sensor-summary?startTimestamp=${date[0]}&endTimestamp=${date[1]}`;
  }

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include' // Include cookies in the request
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching sensor summary data:', error);
    throw error;
  }
};

export const fetchSensorSummaryDataStandAlone = async (unitId, date) => {

  let apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/sensor-summary`;

  // if (date) {
  //     apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/sensor-summary?startTimestamp=${date}`;
  // } 

  // Check if 'date' is a single date object or an array with two date objects
  if (Array.isArray(date) && date.length === 2) {
    apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/sensor-summary?startTimestamp=${date[0]}&endTimestamp=${date[1]}`;
  }

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include' // Include cookies in the request
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching sensor summary data:', error);
    throw error;
  }
};

export async function manualPairSensor({ sensorId, wheelId, unitType, unitId }) {
  const apiUrl = `${baseUrl}/sensor/manual-pairing`;

  const requestBody = {
    sensorId: Number(sensorId),
    wheelId: String(wheelId),
    unitType,
    unitId: String(unitId)
  };

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    });

    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      console.error('Manual pairing failed:', response.status, responseData);
      return {
        success: false,
        status: response.status,
        message: responseData?.message || 'Manual pairing failed.',
        data: responseData
      };
    }

    return {
      success: true,
      status: response.status,
      message: responseData?.message || 'Manual pairing completed.',
      data: responseData,
      clearedSensorIds: responseData?.clearedSensorIds || []
    };

  } catch (error) {
    console.error('Error during manual pairing:', error);

    return {
      success: false,
      status: null,
      message: 'A network error occurred while manually pairing the sensor.',
      data: null,
      clearedSensorIds: []
    };
  }
}

export async function clearManualPairing(sensorId) {
  const apiUrl = `${baseUrl}/sensor/${sensorId}/info`;

  try {
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        manualPairing: false
      })
    });

    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        message:
          response.status === 403
            ? 'Administrator access is required to clear manual pairing.'
            : responseData?.message || 'Could not clear manual pairing.',
        data: responseData
      };
    }

    return {
      success: true,
      status: response.status,
      message: responseData?.message || 'Manual pairing cleared.',
      data: responseData
    };

  } catch (error) {
    console.error('Error clearing manual pairing:', error);

    return {
      success: false,
      status: null,
      message: 'A network error occurred while clearing manual pairing.',
      data: null
    };
  }
}

